// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__bNfjD","title":"Info_title__2iGnD","selects":"Info_selects__3TiqO","requiredAsterisk":"Info_requiredAsterisk__1C8VR"};